import script from "./Main-Library-Upload.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Library-Upload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__